import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Typography } from "antd";
import { useSelector } from "react-redux";
import { selectPatientCycles, selectSelectedOrderId } from "../../store/selector";
import { SEC_FONT_GREY, GRAY_50 } from "../../constant/colors";
import OrderSwitchingDropdown from "../OrderSwitchingDropdown";

const { Text } = Typography;

const CycleFormItemComponent = ({
  t,
  patient,
  defaultValue,
  title,
  style,
  showLabel = false,
  editable = true,
  strong = false,
  required = false,
  dataTMId
}) => {
  const cycles = useSelector(selectPatientCycles);
  const selectedOrderId = useSelector(selectSelectedOrderId);

  // Get currentOrderIndex for status determination (always based on patient's actual current order)
  const currentOrderIndex = patient?.currentOrder?.orderIndex;

  // Calculate the value to use in the select - use selectedOrderId to find the cycle number
  const selectValue =
    selectedOrderId !== null && selectedOrderId !== undefined
      ? cycles?.findIndex((cycle) => cycle.id === selectedOrderId) + 1
      : defaultValue;

  // Wrapper component to integrate OrderSwitchingDropdown with Ant Design Form
  const FormOrderDropdown = ({ value, onChange }) => (
    <OrderSwitchingDropdown
      orders={cycles}
      selectedOrderId={value || selectValue}
      currentOrderIndex={currentOrderIndex}
      onOrderChange={onChange}
      disabled={false}
      valueField="cycleNumber"
      placeholder={t("form.cycle.placeholder")}
      dataTMId={dataTMId}
      backgroundColor={GRAY_50}
    />
  );

  return (
    <Form.Item
      name="cycle"
      colon={false}
      label={
        showLabel ? (
          <Text strong={strong} style={{ color: SEC_FONT_GREY }}>
            {title ? title : t("form.cycle.label")}
          </Text>
        ) : null
      }
      rules={[{ required: required, message: t("form.cycle.error_required") }]}
      style={style}
    >
      {editable ? (
        <FormOrderDropdown />
      ) : (
        <Text data-tm-id={dataTMId}>{defaultValue ? defaultValue : t("patient.general.cycle_placeholder")}</Text>
      )}
    </Form.Item>
  );
};

const CycleFormItem = withTranslation()(CycleFormItemComponent);

export { CycleFormItem };
